import _css from '@emotion/css';
import _extends from '@babel/runtime/helpers/extends';
import { keyframes, jsx } from '@emotion/core';

var defaultStyles = {
  size: 50,
  width: 6,
  primaryColor: '#5e72e4',
  secondaryColor: '#dddbd3'
};
var rotate = keyframes({
  '0%': {
    transform: 'rotate(0deg)'
  },
  '100%': {
    transform: 'rotate(360deg)'
  }
});

var Spinner = function Spinner(_ref) {
  var customStyles = _ref.styles;

  var _defaultStyles$custom = _extends({}, defaultStyles, customStyles),
      width = _defaultStyles$custom.width,
      size = _defaultStyles$custom.size,
      primaryColor = _defaultStyles$custom.primaryColor,
      secondaryColor = _defaultStyles$custom.secondaryColor;

  return jsx("div", {
    css:
    /*#__PURE__*/
    _css({
      position: 'relative',
      boxSizing: 'border-box',
      width: size,
      height: size,
      borderTop: width + "px solid " + secondaryColor,
      borderRight: width + "px solid " + secondaryColor,
      borderBottom: width + "px solid " + secondaryColor,
      borderLeft: width + "px solid " + primaryColor,
      borderRadius: '50%',
      animation: rotate + " 1.1s infinite linear"
    })
  });
};

Spinner.defaultProps = {
  styles: {}
};

export default Spinner;
